module.exports = __webpack_public_path__ + "img/breezyhr.31fd7d90.png";